
$(document).on("click", ".switcher", function () {
    if (!$(this).hasClass("disabled")) {
        var state = $(this).children("input:checked").length > 0;

        $(this).children('span').css("left", state ? "20px" : "0px");
        $(this).toggleClass('on', state);
        
        $.event.trigger({
            type: "switchChanged",
            sender: $(this),
            checked: state
        });
    }
});